const Mode = {
    formFilling: "application",
    editing: "editing",
    signing: "signing",
    edbEditing: "edbEditing",
    edbApproval: "edbApproval",
    readOnly: "readOnly",
    savedDraft: "savedDraft",
};

export default Mode;
